module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1521-9add0b7379299db9ff4fafbdeeb8160f.png";